import React from 'react';
import { Helmet } from 'react-helmet';
import PricingSection from '../components/PricingSection';

const PricingPage = () => {
    return (
        <>
            <Helmet>
                <title>GarageHero - Escolha o Melhor Plano</title>
                <meta name="description" content="Compare os planos GarageHero e encontre o ideal para o seu negócio. Planos Profissional e Para Empresas com teste grátis por 14 dias." />
                <meta property="og:title" content="GarageHero - Escolha o Melhor Plano" />
                <meta property="og:description" content="Compare os planos GarageHero e encontre o ideal para o seu negócio. Planos Profissional e Para Empresas com teste grátis por 14 dias." />
            </Helmet>
            <PricingSection standalone={true} />
        </>
    );
};

export default PricingPage;